<div class="container find-user-container">
  <div class="find-user-table-container">

    <h3>Результат поиска:</h3>

    <mat-table [dataSource]="findUsersDataSource" class="find-user-table">

      <!-- avatar Column -->
      <ng-container matColumnDef="count">
        <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
        <mat-cell *matCellDef="let element; let i=index">{{i + 1}}</mat-cell>
      </ng-container>

      <!-- name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>Имя</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="avatar-container">
            <img class="avatar" src="{{element.avatar}}" alt="-">
          </div>
          <span class="ellipsis-text"><a [routerLink]="['../../user', element.id]">{{element.name}}</a></span>
        </mat-cell>
      </ng-container>

      <!-- dateAdded Column -->
      <ng-container matColumnDef="dateAdded">
        <mat-header-cell *matHeaderCellDef>Зарегистрирован</mat-header-cell>
        <mat-cell *matCellDef="let element">  {{element.dateAdded | date: 'dd.MM.yy HH:mm'}}</mat-cell>
      </ng-container>

      <!-- ip Column -->
      <ng-container matColumnDef="ip">
        <mat-header-cell *matHeaderCellDef>IP</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.ip then ip; else empty"></ng-container>
          <ng-template #ip>
                  <span class="ellipsis-text"><a
                    [routerLink]="['/user/check/ip', element.ip]"
                  >{{element.ip || '-'}}</a ></span>
          </ng-template>
          <ng-template #empty>-</ng-template>
        </mat-cell>
      </ng-container>

      <!-- coinsAmount Column -->
      <ng-container matColumnDef="coinsAmount">
        <mat-header-cell *matHeaderCellDef>Баланс</mat-header-cell>
        <mat-cell *matCellDef="let element">
            <span
              matTooltip="{{element.coinsAmount | fastCoinsToDollar}}"
              matTooltipPosition="above"
              [matTooltipDisabled]="!isGoFast"
            >{{element.coinsAmount / 100 | number }}</span>
        </mat-cell>
      </ng-container>

      <!-- isLocked Column -->
      <ng-container matColumnDef="isLocked">
        <mat-header-cell *matHeaderCellDef>Заблокирован</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="ellipsis-text">{{element.isLocked ? 'Да' : 'Нет'}}</span>
        </mat-cell>
      </ng-container>


      <mat-header-row *matHeaderRowDef="findUsersColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: findUsersColumns;"></mat-row>

      <div class="empty-data" *matNoDataRow>
        <p>Данные отсутствуют</p>
      </div>
    </mat-table>
    <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
  </div>

</div>
